import { Box, Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { sportTypesCollRef } from "../../../utils/referencies";

const SportType: FC<any> = (props) => {
  const record = props.record;

  const [sportTypeId, setSportTypeId] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const fetchSportTypesId = async () => {
    setLoading(true);
    try {
      const snapshot = await sportTypesCollRef.get();
      if (!snapshot.empty) {
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().title.en,
        }));
        const selectedSportType = data.filter((sport) => sport.id === record.sportTypeId);
        setSportTypeId(selectedSportType[0].name as string);
      }
      setLoading(false);
    } catch (ex: any) {
      console.log(ex.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSportTypesId();
  }, []);

  return (
    <Box style={{ width: 100 }}>
      <Loader loading={loading}>
        <Typography variant="body2">{sportTypeId}</Typography>
      </Loader>
    </Box>
  );
};

export default SportType;
